import React from "react";
import { Row, Col, Card, Tooltip, Space } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import { getActiveUser } from "../../lib/getActiveUser";
import {
  MENU_USER_USERMANAGEMENT_WRITE,
  USERMANAGEMENT_USER_ACTIONS,
} from "../../../../lib/const/permissions";
import { hasAccess } from "../../hasAccess";

const gutter = [20, 20];

const styles = {
  row: {
    marginBottom: "23px",
  },
};

function UserInfoCard(props) {
  const { user, userActions, userActiveAction } = props;

  return (
    <Card
      style={styles.card}
      title={
        <div
          className="my-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Space>
            Пользователь
            {user.userType === "external" && (
              <Tooltip title="Для уточнения привилегий пользователя обратитесь к Администратору AD">
                <LinkOutlined />
              </Tooltip>
            )}
            {userActiveAction && userActiveAction}
            {user.userType === "internal" && (
              <span style={{ fontSize: "12px" }}>
                {getActiveUser(user) ? "Включён" : "Отключён"}
              </span>
            )}
          </Space>
          {userActions && userActions}
        </div>
      }
    >
      <Row style={styles.row} gutter={gutter}>
        <Col span={8}>Фамилия</Col>
        <Col>{user.lastName}</Col>
      </Row>
      <Row style={styles.row} gutter={gutter}>
        <Col span={8}>Имя</Col>
        <Col>{user.firstName}</Col>
      </Row>
      <Row style={styles.row} gutter={gutter}>
        <Col span={8}>Отчество</Col>
        <Col>{user.userInfo.middleName || ""}</Col>
      </Row>
      <Row style={styles.row} gutter={gutter}>
        <Col span={8}>Логин</Col>
        <Col>{user.login}</Col>
      </Row>
      <Row style={styles.row} gutter={gutter}>
        <Col span={8}>E-mail</Col>
        <Col>{user.email}</Col>
      </Row>
    </Card>
  );
}

export default UserInfoCard;
